package com.milta.core.localization.translations.it

import com.milta.core.localization.HomeStrings

internal val Home = HomeStrings(
    navTournee = "Giro",
    navEcoDriving = "Eco guida",
    navCommunity = "Comunità",
    navRewards = "Premi",
    navHome = "Home",
    navRoutes = "Percorsi",
    navTeam = "Team",
    navProfile = "Profilo",
    navDashboard = "Dashboard",
)
